import React from "react";
import SettingsIcon from "@material-ui/icons/Settings";
import { ButtonOfSettings } from "./BtnFeelingFacesConfig.styled";
import { theme as themeConfig } from "../../../themes/themes";

const BtnFeelingFacesConfig = ({ hideconfig, handleMoodMeterSettings }) => {
  return (
    <>
      <ButtonOfSettings
        onClick={() => handleMoodMeterSettings()}
        hidden={hideconfig}
      >
        <SettingsIcon
          style={{ color: themeConfig.neutral.gray[2600], width: "15px", height: "15px" }}
        />{" "}
        Settings
      </ButtonOfSettings>
    </>
  );
};

export default BtnFeelingFacesConfig;
